<template>
  <div>
    <v-row>
      <v-col>
        <h2>{{ pageTitle }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col cols="12" align="center">
              <v-text-field
                label="Название меню"
                v-model="menu.name"
                required
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center"
              ><v-autocomplete
                :items="categories"
                item-title="text"
                item-value="value"
                label="Выберите категорию"
                v-model="menu.categoryId"
              ></v-autocomplete
            ></v-col>
            <v-col cols="12" align="center"
              ><v-autocomplete
                :items="subcategories"
                item-title="text"
                item-value="value"
                multiple
                label="Выберите подкатегории"
                v-model="menu.subcategories"
              ></v-autocomplete
            ></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" @click="update"> Сохранить </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const MenuCategoryRepository = RepositoryFactory.get("menuCategory");
const CategoriesRepository = RepositoryFactory.get("category");
const SubcategoriesRepository = RepositoryFactory.get("subCategory");

export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      menu: {
        id: 0,
        name: "Пункт меню",
        categoryId: null,
        subcategories: [],
      },
      nameRules: [
        (value) => {
          if (value) return true;

          return "Поле обязательно для заполнения.";
        },
      ],
      categories: [],
      subcategories: [],
    };
  },
  mounted() {
    this.getCategories();
    this.get();
  },
  methods: {
    async getCategories() {
      const result = await CategoriesRepository.getCategoriesForSelect();
      if (result.data.status === "success") {
        this.categories = result.data.data;
      }
    },
    async getSubcategories(categoryId) {
      const result =
        await SubcategoriesRepository.getCategoriesByCategoryForSelect(
          categoryId
        );
      if (result.data.status === "success") {
        this.subcategories = result.data.data;
      }
    },
    async get() {
      if (this.$route.params.id > 0) {
        this.isLoading = true;
        const result = await MenuCategoryRepository.get(this.$route.params.id);
        if (result) {
          if (result.data.status === "success") {
            this.menu = result.data.data;
          }
        }

        this.isLoading = false;
      }
    },
    async create() {
      this.isLoading = true;
      const formData = new FormData();

      const result = await MenuCategoryRepository.create(this.menu);
      if (result.data.status === "success") {
        this.menu = result.data.data;
        this.$router.replace({
          path: `/menu-categories/${result.data.data.id}/edit`,
        });
      }
      this.isLoading = false;
    },
    async update() {
      if (this.menu.id > 0) {
        this.isLoading = true;

        const result = await MenuCategoryRepository.update(this.menu);

        this.isLoading = false;
      } else {
        await this.create();
      }
    },
  },
  computed: {
    showFileInput: {
      get() {
        return this.applyImageChange || this.menu.id == 0;
      },
    },
    pageTitle: {
      get() {
        return (
          (this.menu.id > 0 ? "Редактирование " : "Создание ") +
          "пункта меню '" +
          this.menu.name +
          "'"
        );
      },
    },
  },
  watch: {
    "menu.categoryId": function (newVal, oldVal) {
      if (newVal != oldVal && newVal > 0) {
        this.getSubcategories(newVal);
      }
    },
  },
};
</script>
